/* Birth Profile — geboorteplaats autocomplete
   Attaches a styled typeahead to any input with [data-city-autocomplete].
   Pure client-side, curated city list (NL/BE focused + major world cities). */
(function(){
  "use strict";

  var CITIES = [
    // ---- Nederland ----
    "Amsterdam, Nederland","Rotterdam, Nederland","Den Haag, Nederland","Utrecht, Nederland",
    "Eindhoven, Nederland","Groningen, Nederland","Tilburg, Nederland","Almere, Nederland",
    "Breda, Nederland","Nijmegen, Nederland","Apeldoorn, Nederland","Haarlem, Nederland",
    "Arnhem, Nederland","Enschede, Nederland","Amersfoort, Nederland","Zaanstad, Nederland",
    "'s-Hertogenbosch, Nederland","Zwolle, Nederland","Zoetermeer, Nederland","Leiden, Nederland",
    "Leeuwarden, Nederland","Maastricht, Nederland","Dordrecht, Nederland","Ede, Nederland",
    "Alphen aan den Rijn, Nederland","Alkmaar, Nederland","Emmen, Nederland","Delft, Nederland",
    "Venlo, Nederland","Deventer, Nederland","Helmond, Nederland","Oss, Nederland",
    "Amstelveen, Nederland","Hilversum, Nederland","Heerlen, Nederland","Hengelo, Nederland",
    "Purmerend, Nederland","Roosendaal, Nederland","Schiedam, Nederland","Lelystad, Nederland",
    "Almelo, Nederland","Gouda, Nederland","Vlaardingen, Nederland","Assen, Nederland",
    "Bergen op Zoom, Nederland","Veenendaal, Nederland","Katwijk, Nederland","Hoorn, Nederland",
    "Middelburg, Nederland","Den Helder, Nederland","Kampen, Nederland","Doetinchem, Nederland",
    "Terneuzen, Nederland","Harderwijk, Nederland","Weert, Nederland","Tiel, Nederland",
    "Wageningen, Nederland","Sneek, Nederland","Goes, Nederland","Zutphen, Nederland",
    "Hoofddorp, Nederland","Roermond, Nederland","Heerhugowaard, Nederland","Nieuwegein, Nederland",
    "Veldhoven, Nederland","Barneveld, Nederland","Houten, Nederland","Oosterhout, Nederland",
    "Rijswijk, Nederland","Woerden, Nederland","Waalwijk, Nederland","Soest, Nederland",
    "Capelle aan den IJssel, Nederland","Zeist, Nederland","Vlissingen, Nederland","Kerkrade, Nederland",
    "Uden, Nederland","Beverwijk, Nederland","IJmuiden, Nederland","Wassenaar, Nederland",
    "Diemen, Nederland","Voorburg, Nederland","Leidschendam, Nederland","Bussum, Nederland",
    "Naarden, Nederland","Weesp, Nederland","Castricum, Nederland","Volendam, Nederland",
    "Edam, Nederland","Texel, Nederland","Drachten, Nederland","Heerenveen, Nederland",
    "Harlingen, Nederland","Dokkum, Nederland","Veendam, Nederland","Hoogeveen, Nederland",
    "Meppel, Nederland","Coevorden, Nederland","Steenwijk, Nederland","Urk, Nederland",
    "Emmeloord, Nederland","Dronten, Nederland","Nijkerk, Nederland","Ermelo, Nederland",
    "Nunspeet, Nederland","Elburg, Nederland","Zevenaar, Nederland","Winterswijk, Nederland",
    "Wijchen, Nederland","Cuijk, Nederland","Boxmeer, Nederland","Gennep, Nederland",
    "Veghel, Nederland","Boxtel, Nederland","Vught, Nederland","Rosmalen, Nederland",
    "Etten-Leur, Nederland","Zundert, Nederland","Tholen, Nederland","Zierikzee, Nederland",
    "Hulst, Nederland","Geleen, Nederland","Brunssum, Nederland","Landgraaf, Nederland",
    "Valkenburg, Nederland","Stein, Nederland","Beek, Nederland","Echt, Nederland",
    // ---- België ----
    "Brussel, België","Antwerpen, België","Gent, België","Charleroi, België","Luik, België",
    "Brugge, België","Namen, België","Leuven, België","Mechelen, België","Aalst, België",
    "Kortrijk, België","Hasselt, België","Oostende, België","Genk, België","Sint-Niklaas, België",
    "Roeselare, België","Doornik, België","Bergen, België","Turnhout, België","Dendermonde, België",
    "Verviers, België","Moeskroen, België","Vilvoorde, België","Lokeren, België",
    "Beveren, België","Geel, België","Wevelgem, België","Ieper, België",
    "Knokke-Heist, België","Waregem, België","Ninove, België","Lier, België",
    "Tienen, België","Halle, België","Tongeren, België","Aarschot, België",
    // ---- Europa ----
    "Londen, Verenigd Koninkrijk","Manchester, Verenigd Koninkrijk","Edinburgh, Verenigd Koninkrijk",
    "Dublin, Ierland","Parijs, Frankrijk","Marseille, Frankrijk","Lyon, Frankrijk","Nice, Frankrijk",
    "Berlijn, Duitsland","München, Duitsland","Hamburg, Duitsland","Keulen, Duitsland",
    "Frankfurt, Duitsland","Düsseldorf, Duitsland","Madrid, Spanje","Barcelona, Spanje",
    "Valencia, Spanje","Sevilla, Spanje","Málaga, Spanje","Lissabon, Portugal","Porto, Portugal",
    "Rome, Italië","Milaan, Italië","Napels, Italië","Turijn, Italië","Florence, Italië",
    "Venetië, Italië","Wenen, Oostenrijk","Zürich, Zwitserland","Genève, Zwitserland",
    "Stockholm, Zweden","Kopenhagen, Denemarken","Oslo, Noorwegen","Helsinki, Finland",
    "Warschau, Polen","Krakau, Polen","Praag, Tsjechië","Boedapest, Hongarije",
    "Boekarest, Roemenië","Athene, Griekenland","Istanboel, Turkije","Moskou, Rusland",
    "Kiev, Oekraïne","Belgrado, Servië","Zagreb, Kroatië","Sofia, Bulgarije","Luxemburg, Luxemburg",
    "Glasgow, Verenigd Koninkrijk","Birmingham, Verenigd Koninkrijk","Liverpool, Verenigd Koninkrijk",
    "Bristol, Verenigd Koninkrijk","Cardiff, Verenigd Koninkrijk","Belfast, Verenigd Koninkrijk",
    "Bordeaux, Frankrijk","Toulouse, Frankrijk","Lille, Frankrijk","Straatsburg, Frankrijk",
    "Nantes, Frankrijk","Stuttgart, Duitsland","Dortmund, Duitsland","Essen, Duitsland",
    "Bremen, Duitsland","Hannover, Duitsland","Leipzig, Duitsland","Dresden, Duitsland",
    "Neurenberg, Duitsland","Bonn, Duitsland","Aken, Duitsland","Münster, Duitsland",
    "Bilbao, Spanje","Zaragoza, Spanje","Granada, Spanje","Alicante, Spanje",
    "Palma de Mallorca, Spanje","Las Palmas, Spanje","Bologna, Italië","Genua, Italië",
    "Verona, Italië","Palermo, Italië","Catania, Italië","Bari, Italië",
    "Bern, Zwitserland","Basel, Zwitserland","Salzburg, Oostenrijk","Innsbruck, Oostenrijk",
    "Graz, Oostenrijk","Göteborg, Zweden","Malmö, Zweden","Bergen, Noorwegen",
    "Aarhus, Denemarken","Reykjavik, IJsland","Tallinn, Estland","Riga, Letland",
    "Vilnius, Litouwen","Gdansk, Polen","Wroclaw, Polen","Poznan, Polen",
    "Brno, Tsjechië","Bratislava, Slowakije","Ljubljana, Slovenië","Sarajevo, Bosnië en Herzegovina",
    "Thessaloniki, Griekenland","Valletta, Malta","Nicosia, Cyprus","Izmir, Turkije",
    "Antalya, Turkije","Sint-Petersburg, Rusland",
    // ---- Amerika ----
    "New York, Verenigde Staten","Los Angeles, Verenigde Staten","Chicago, Verenigde Staten",
    "Miami, Verenigde Staten","San Francisco, Verenigde Staten","Toronto, Canada",
    "Vancouver, Canada","Montreal, Canada","Mexico-stad, Mexico","São Paulo, Brazilië",
    "Rio de Janeiro, Brazilië","Buenos Aires, Argentinië","Lima, Peru","Bogotá, Colombia",
    "Santiago, Chili","Paramaribo, Suriname","Willemstad, Curaçao","Oranjestad, Aruba",
    "Kralendijk, Bonaire",
    "Boston, Verenigde Staten","Washington D.C., Verenigde Staten","Houston, Verenigde Staten",
    "Philadelphia, Verenigde Staten","San Diego, Verenigde Staten","Dallas, Verenigde Staten",
    "Seattle, Verenigde Staten","Atlanta, Verenigde Staten","Denver, Verenigde Staten",
    "Las Vegas, Verenigde Staten","Calgary, Canada","Ottawa, Canada","Quebec, Canada",
    "Guadalajara, Mexico","Monterrey, Mexico","Havana, Cuba","Santo Domingo, Dominicaanse Republiek",
    "San Juan, Puerto Rico","Kingston, Jamaica","Quito, Ecuador","Caracas, Venezuela",
    "Medellín, Colombia","Cali, Colombia","Montevideo, Uruguay","La Paz, Bolivia",
    "Brasília, Brazilië","Salvador, Brazilië","Recife, Brazilië",
    // ---- Afrika & Midden-Oosten ----
    "Caïro, Egypte","Casablanca, Marokko","Rabat, Marokko","Marrakech, Marokko","Tunis, Tunesië",
    "Algiers, Algerije","Lagos, Nigeria","Nairobi, Kenia","Johannesburg, Zuid-Afrika",
    "Kaapstad, Zuid-Afrika","Dubai, Verenigde Arabische Emiraten","Tel Aviv, Israël",
    "Beiroet, Libanon","Riyad, Saoedi-Arabië","Teheran, Iran",
    "Accra, Ghana","Abidjan, Ivoorkust","Dakar, Senegal","Addis Abeba, Ethiopië",
    "Dar es Salaam, Tanzania","Kampala, Oeganda","Kinshasa, DR Congo","Luanda, Angola",
    "Maputo, Mozambique","Harare, Zimbabwe","Khartoem, Soedan","Tripoli, Libië",
    "Alexandrië, Egypte","Fez, Marokko","Tanger, Marokko","Agadir, Marokko",
    "Amman, Jordanië","Damascus, Syrië","Bagdad, Irak","Doha, Qatar",
    "Abu Dhabi, Verenigde Arabische Emiraten","Jeddah, Saoedi-Arabië","Jeruzalem, Israël",
    // ---- Azië & Oceanië ----
    "Mumbai, India","New Delhi, India","Bangalore, India","Bangkok, Thailand","Singapore, Singapore",
    "Hongkong, China","Peking, China","Shanghai, China","Tokio, Japan","Osaka, Japan",
    "Seoul, Zuid-Korea","Jakarta, Indonesië","Bali, Indonesië","Manila, Filipijnen",
    "Sydney, Australië","Melbourne, Australië","Auckland, Nieuw-Zeeland",
    "Karachi, Pakistan","Lahore, Pakistan","Islamabad, Pakistan","Dhaka, Bangladesh",
    "Colombo, Sri Lanka","Kathmandu, Nepal","Chennai, India","Kolkata, India",
    "Hyderabad, India","Pune, India","Jaipur, India","Kuala Lumpur, Maleisië",
    "Ho Chi Minhstad, Vietnam","Hanoi, Vietnam","Phnom Penh, Cambodja","Taipei, Taiwan",
    "Guangzhou, China","Shenzhen, China","Chengdu, China","Kyoto, Japan",
    "Nagoya, Japan","Sapporo, Japan","Busan, Zuid-Korea","Surabaya, Indonesië",
    "Bandung, Indonesië","Cebu, Filipijnen","Brisbane, Australië","Perth, Australië",
    "Adelaide, Australië","Wellington, Nieuw-Zeeland","Christchurch, Nieuw-Zeeland"
  ];

  var css =
    ".ac-list{position:fixed;z-index:60;background:#0c1c3d;border:1px solid rgba(201,169,106,0.4);" +
    "max-height:248px;overflow-y:auto;box-shadow:0 20px 46px rgba(0,0,0,0.5);display:none;" +
    "font-family:'Mulish',system-ui,sans-serif}" +
    ".ac-list.open{display:block}" +
    ".ac-item{padding:11px 14px;font-size:13.5px;color:#cfd6e8;cursor:pointer;display:flex;" +
    "gap:10px;align-items:center;border-bottom:1px solid rgba(201,169,106,0.08);line-height:1.2}" +
    ".ac-item:last-child{border-bottom:0}" +
    ".ac-item.active,.ac-item:hover{background:rgba(201,169,106,0.16);color:#f3ead6}" +
    ".ac-item .ci{width:14px;height:14px;flex:0 0 auto;color:#c9a96a}" +
    ".ac-item b{color:#e7c98a;font-weight:600}" +
    ".ac-empty{padding:12px 14px;font-size:12.5px;color:#8b94ad;font-family:'Mulish',system-ui,sans-serif}" +
    ".ac-list::-webkit-scrollbar{width:8px}" +
    ".ac-list::-webkit-scrollbar-thumb{background:rgba(201,169,106,0.3);border-radius:4px}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s){ return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }

  function attach(input){
    if(input.dataset.acBound) return;
    input.dataset.acBound = "1";
    input.setAttribute("autocomplete","off");
    input.setAttribute("spellcheck","false");

    var list = document.createElement("div");
    list.className = "ac-list";
    list.setAttribute("role","listbox");
    document.body.appendChild(list);

    var items = [], active = -1;

    function position(){
      var r = input.getBoundingClientRect();
      list.style.left = r.left + "px";
      list.style.top = (r.bottom + 4) + "px";
      list.style.width = r.width + "px";
    }
    function close(){ list.classList.remove("open"); active = -1; }

    function clearErr(){
      var f = input.closest(".bfield") || input.closest(".field");
      if(f) f.classList.remove("err");
    }

    function render(){
      var q = input.value.trim().toLowerCase();
      if(q.length < 1){ close(); return; }
      var starts = [], incl = [];
      for(var i=0;i<CITIES.length;i++){
        var lc = CITIES[i].toLowerCase();
        if(lc.indexOf(q) === 0) starts.push(CITIES[i]);
        else if(lc.indexOf(q) > 0) incl.push(CITIES[i]);
      }
      items = starts.concat(incl).slice(0,8);
      if(items.length === 0){
        list.innerHTML = '<div class="ac-empty">Geen plaats gevonden — je kunt hem ook handmatig typen</div>';
        list.classList.add("open"); position(); active = -1; return;
      }
      var html = "";
      for(var j=0;j<items.length;j++){
        var c = items[j], lcj = c.toLowerCase(), idx = lcj.indexOf(q), label;
        if(idx >= 0){
          label = esc(c.slice(0,idx)) + "<b>" + esc(c.slice(idx, idx+q.length)) + "</b>" + esc(c.slice(idx+q.length));
        } else { label = esc(c); }
        html += '<div class="ac-item" role="option" data-i="'+j+'">' +
          '<svg class="ci" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">' +
          '<path d="M12 21s-6-5.7-6-10a6 6 0 0 1 12 0c0 4.3-6 10-6 10z"/><circle cx="12" cy="11" r="2"/></svg>' +
          '<span>'+label+'</span></div>';
      }
      list.innerHTML = html;
      list.classList.add("open"); position(); active = -1;
    }

    function upd(){
      var kids = list.children;
      for(var i=0;i<kids.length;i++) kids[i].classList.toggle("active", i === active);
      if(active >= 0 && kids[active]) kids[active].scrollTop;
    }
    function choose(i){
      if(items[i]){
        input.value = items[i];
        clearErr();
        // dispatch 'change' only — dispatching 'input' would re-trigger the
        // suggestion list and immediately reopen it
        input.dispatchEvent(new Event("change",{bubbles:true}));
        close();
      }
    }

    input.addEventListener("input", render);
    input.addEventListener("focus", function(){ if(input.value.trim()) render(); });
    input.addEventListener("keydown", function(e){
      if(!list.classList.contains("open")) return;
      if(e.key === "ArrowDown"){ e.preventDefault(); active = Math.min(items.length-1, active+1); upd(); }
      else if(e.key === "ArrowUp"){ e.preventDefault(); active = Math.max(0, active-1); upd(); }
      else if(e.key === "Enter"){ if(active >= 0){ e.preventDefault(); choose(active); } }
      else if(e.key === "Escape"){ close(); }
    });
    list.addEventListener("mousedown", function(e){
      var it = e.target.closest(".ac-item");
      if(it){ e.preventDefault(); choose(parseInt(it.dataset.i,10)); }
    });
    document.addEventListener("click", function(e){
      if(e.target !== input && !list.contains(e.target)) close();
    });
    window.addEventListener("scroll", function(){ if(list.classList.contains("open")) position(); }, true);
    window.addEventListener("resize", function(){ if(list.classList.contains("open")) position(); });
  }

  function init(){
    var inputs = document.querySelectorAll("[data-city-autocomplete]");
    for(var i=0;i<inputs.length;i++) attach(inputs[i]);
  }
  if(document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
